/* eslint @typescript-eslint/no-explicit-any: "off", "no-console": "off" */

import { ApiError } from '@api/utils/ApiError';

export class Log {

	static userId: number = null;

	static logs: string[] = [];

	static readonly MAX_ITEMS: number = 300;

	static setUserId(userId: number) {
		this.userId = userId;
	}

	static getUserId(): number {
		return this.userId;
	}

	protected static logIt(log: string[], options?: { showDate?: boolean; showUser?: boolean; style?: { [key: string]: string} }) {
		const {
			showDate = true,
			showUser = true,
			style = {},
		} = options || {};
		const styles = { 'color': 'gray', 'font-size': '10px', ...style };
		const infoStyles = (console && console.log)
			? Object.entries(styles)
				.map((el: string[]) => `${el[0]}: ${el[1]}`)
				.join('; ')
			: null;
		const date = new Date();
		const fixToDouble = (str: number) => ('0' + str).slice(-2);
		const formattedDate = `${fixToDouble(date.getDate())
		}.${fixToDouble(date.getMonth() + 1)
		}.${fixToDouble(date.getFullYear())
		} ${fixToDouble(date.getHours())
		}:${fixToDouble(date.getMinutes())
		}:${fixToDouble(date.getSeconds())
		}`;
		const info = `${showDate ? formattedDate + ':' : ''}${showUser && this.userId ? ` userId: ${this.userId}: ` : ''}`;
		const styledInfo = infoStyles ? [`%c${info}`, infoStyles] : [info];
		const message = [...styledInfo, ...log];

		if (console && console.log) {
			console.log(...message);
		}

		if (!IS_SSR) {
			this.logs.push(message.join(' '));
			this.slice();
		}
	}

	static message(...args: any[]) {
		this.logIt(args);
	}

	static error(...args: any[]) {
		this.logIt(args, { style: { 'background': '#ffe5e5', 'color': 'red' } });
	}

	static warn(...args: any[]) {
		this.logIt(args, { style: { 'background': '#fffec7', 'color': '#a58a00' } });
	}

	static errorRequest(err: ApiError) {
		if (err && err.request) {
			const {
				status,
				request: {
					url = '',
					method = '',
					data,
				},
			} = err;

			Log.error(`Failed network request: ${status} ${method.toUpperCase()} ${url} ${data}`);
		}
	}

	static slice() {
		this.logs = this.logs.slice(-this.MAX_ITEMS);
	}

	static getLogs() {
		return this.logs;
	}

}
